/** Held this long on another player, a finger asks for their menu, like a title (ADR 0043). */
export const PLAYER_PRESS_MS = 450;
/** A finger drifting further than this (screen px) is walking, not pressing. */
export const PLAYER_PRESS_SLOP_PX = 10;

export type MousePress = 'act' | 'social' | 'ignore';

/**
 * What a mouse button asks of the world (SHE-33): the left one plays (walk,
 * attack, pick up), the right one only opens another player's menu, so a
 * click in a fight never lands on an ally's menu.
 */
export function mousePressOf(button: number, onPlayer: boolean): MousePress {
  if (button === 0) return 'act';
  if (button === 2 && onPlayer) return 'social';
  return 'ignore';
}
